import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-toRight",
  "use": "icon-toRight-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1000 1000\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-toRight\"><defs><style></style></defs><path d=\"M816.703 484.414L408.216 44.392H219.75l408.485 440.022-408.485 408.47h188.467l408.486-408.47zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol